export default __webpack_public_path__ + "static/media/buildingGroup.2cb9325f.svg";